import React, { useState } from "react";
import Text from "~/components-shared/Text";
import Card from "~/components-shared/Card/Card";
import styled from "styled-components";
import { Alert, Badge, Box, Button, Icon } from "~/components-shared";
import mixpanel from "mixpanel-browser";
import trendReportsActionCreators from "~/store/trendReports/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import trendReportSelectors from "~/store/trendReports/selectors";
import toastsActionCreators from "~/store/toasts/actions";
import { StatusStateEnum } from "~/types/enums";
const Contributions = styled.div`
  background: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.primary.light;
}};
  width: calc(100% + 2.8em);
  padding: 1.5em 1em;
  text-align: center;
  margin: 0 -1.4em;
  border-bottom-left-radius: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.shape.borderRadius.primary;
}};
  border-bottom-right-radius: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.shape.borderRadius.primary;
}};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const StyledBox = styled(Box)`
  position: absolute;
  top: 5px;
  right: 5px;
`;
const CustomerItemCard = _ref4 => {
  let {
    showDismissed,
    item,
    ...rest
  } = _ref4;
  const {
    t
  } = useTranslation();
  const [itemState, setItemState] = useState(item);
  const dismissStatus = useSelector(trendReportSelectors.getStatusByTrend(item.id));
  const dismissError = useSelector(trendReportSelectors.getErrorByTrend(item.id));
  const error = dismissError;
  const dispatch = useDispatch();
  if (!itemState || !showDismissed && itemState.isDismissed) {
    return null;
  }
  const handleToggleDismiss = () => {
    if (item.reportId) {
      dispatch(trendReportsActionCreators.dismissTrendStarted(item.reportId, item.id, _ref5 => {
        let {
          data
        } = _ref5;
        if (data) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("TrendingItemCard.successfullyDismissed", {
              name: item?.name
            }),
            timeout: 10000
          }));
          setItemState(prev => ({
            ...prev,
            isDismissed: true
          }));
          mixpanel.track(`Insights Customer Trends – Dismiss`, {
            lineItemId: item.id
          });
        }
      }));
    }
  };
  return /*#__PURE__*/React.createElement(Card, rest, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    s: {
      mb: 3
    },
    weight: "semiBold"
  }, item.workType), /*#__PURE__*/React.createElement(Text, {
    element: "h4",
    s: {
      mb: 4
    },
    display: "block",
    style: {
      width: "100%",
      flexGrow: 1
    },
    textOverflow: true
  }, item.name), /*#__PURE__*/React.createElement(Contributions, null, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    fontSize: 3,
    weight: "semiBold",
    s: {
      mb: 3
    },
    display: "block"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "union",
    s: {
      mr: 1.5,
      mt: -0.5
    },
    color: "primary"
  }), item.contributionCount, " contributions"), /*#__PURE__*/React.createElement(Badge, {
    color: item.isContinuous ? "translucent" : "translucentPrimary",
    s: {
      px: 4
    }
  }, item.isContinuous ? "Recurring" : "New")), /*#__PURE__*/React.createElement(StyledBox, {
    align: "center"
  }, itemState.isDismissed && /*#__PURE__*/React.createElement(Badge, {
    s: {
      px: 3,
      py: 0.5
    },
    color: "translucentDanger"
  }, "Dismissed"), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": itemState.isDismissed ? t("common.actions.restore") : t("common.actions.dismiss"),
    onClick: e => {
      e.stopPropagation();
      handleToggleDismiss();
    },
    color: "transparent",
    rounded: true,
    outline: false,
    loading: dismissStatus === StatusStateEnum.LOADING,
    s: {
      p: 2,
      mx: 0.5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: itemState.isDismissed ? "refresh" : "cross",
    color: "text",
    display: "block"
  }))));
};
export default CustomerItemCard;